import { gql } from '@apollo/client'
import { STORE_ADDRESS_FRAGMENT } from './StoreAddressFragment'

export const PHYSICAL_STORE_FRAGMENT = gql`
  fragment PhysicalStore on Store {
    id
    name
    category
    modified
    image {
      id
      url
    }
    address {
      ...StoreAddress
    }
  }
  ${STORE_ADDRESS_FRAGMENT}
`
